module.exports = require("react-dates");